import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export * from './instructor-balance-details/instructor-balance-details.component';
export * from './instructor-balance.component';

import { Route } from '@angular/router';






export const Routing: Route[] = [
  {
    path: 'payout/instructor-balances',
    loadComponent: () => import('./instructor-balance.component').then(m => m.InstructorBalanceComponent),
    data: { title: marker('E-Commerce'), breadcrumb: 'Instructor Balances' },
  },
  {
    path: 'payout/instructor-balance/:instructorId',
    loadComponent: () => import('./instructor-balance-details/instructor-balance-details.component').then(m => m.InstructorBalanceDetailsComponent),
    data: { title: marker('E-Commerce'), breadcrumb: 'Instructor Balances Details' },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'requests'
      },
      {
        path: 'transactions',
        loadComponent: () => import('./instructor-balance-transactions/instructor-balance-transactions.component').then(m => m.InstructorBalanceTransactionsComponent)
      },
      {
        path: 'requests',
        loadComponent: () => import('./instructor-balance-requests/instructor-balance-requests.component').then(m => m.InstructorBalanceRequestsComponent)
      },
    ]
  },
];
